import ENV from "../env";

export const log = (title, data) => {
  if (ENV.debug_mode) {
    console.log(title);
    if (data) {
      console.log(data);
    }
  }
};

// refactor questions received from api
// to use in front end
export const refactorReviewQuestions = questions => {
  let q_ids = [...new Set(questions.map(item => item.question_id))];
  let final_questions = [];
  // console.log(api_question_ids)
  for (let q_id in q_ids) {
    let same_questions = questions.filter(
      item => item.question_id === q_ids[q_id]
    );
    let question_choices = same_questions.map(function(item) {
      return {
        choice_id: item.choice_id,
        choice_title: item.choice_title,
        is_correct: item.is_correct,
        is_chosen: item.is_chosen
      };
    });
    final_questions.push({
      question_id: same_questions[0].question_id,
      problem_title: same_questions[0].problem_title,
      question_code: same_questions[0].question_code,
      is_flagged: same_questions[0].is_flagged,
      question_feedback: same_questions[0].question_feedback,
      choices: question_choices
    });
  }
  return final_questions;
};

export const refactorExamQuestions = questions => {
  let q_ids = [...new Set(questions.map(item => item.question_id))];
  let final_questions = [];
  for (let q_id in q_ids) {
    let same_questions = questions.filter(
      item => item.question_id === q_ids[q_id]
    );
    let question_choices = same_questions.map(function(item) {
      return {
        choice_id: item.choice_id,
        choice_title: item.choice_title,
        is_chosen: item.is_chosen
      };
    });
    final_questions.push({
      question_id: same_questions[0].question_id,
      problem_title: same_questions[0].problem_title,
      have_multiple_choices: same_questions[0].have_multiple_choices,
      is_flagged: same_questions[0].is_flagged,
      choices: question_choices
    });
  }
  return final_questions;
};
